module.exports = __webpack_public_path__ + "img/24.0849f0f5.svg";